// ESM-Konvertierung von lib/scripts/CLS_CSQLite.js (Phase 4, Welle 2).
// Prototype-Stil bleibt vorerst (Huellen-Muster). Beim Umzug bereinigt:
// die folgenlose top-level this.filename-Zuweisung (in ESM waere this
// undefined) und die toten runAsync/runAsyncExclusive-Helfer (keine
// Aufrufer; haetten mangels underscore _ nie funktioniert).
// Modul-globale queue: Module initialisieren NACH lib/jQuery/Queue.js.
// *** Constructor ***
/*PRAGMA foreign_keys = off;
BEGIN TRANSACTION;

-- Table: BONREG
CREATE TABLE BONREG (ReceiptID INTEGER PRIMARY KEY UNIQUE NOT NULL, Date CHAR (19), TAXNormal DOUBLE DEFAULT (0), TAXErm1 DOUBLE DEFAULT (0), TAXErm2 DOUBLE DEFAULT (0), TAXNull DOUBLE DEFAULT (0), TAXBes DOUBLE DEFAULT (0), TurnoverEncr CHAR (16), CertSerial CHAR (32), PosID CHAR (32), TurnoverCounter DOUBLE, SigHex CHAR (16), BON_ID INTEGER);

COMMIT TRANSACTION;
PRAGMA foreign_keys = on;*/
var queue = new Queue();

// Routing-Freeze-Check (Plan sharded-hatching-clover, Phase 1): das
// Master/Slave-Routing haengt an Substring-Matches auf dem SQL-TEXT
// (executeSQL unten) - jede Umformatierung eines SQL-Strings in spaeteren
// Refactor-Phasen kann das Routing stillschweigend aendern. Deshalb wird
// jede Routing-Entscheidung in einen reinen In-Memory-Ringpuffer
// geschrieben (kein I/O, kein Verhaltenseinfluss); Testlaeufe lesen ihn
// per page.evaluate aus und diffen ihn vor/nach jeder Phase.
var ROUTING_LOG_MAX = 5000;
function recordRouting(endpoint, sql) {
    try {
        window.POSDIAG = window.POSDIAG || {};
        var rl = window.POSDIAG.routingLog = window.POSDIAG.routingLog || [];
        rl.push(endpoint + " | " + String(sql).slice(0, 100));
        if (rl.length > ROUTING_LOG_MAX) rl.splice(0, rl.length - ROUTING_LOG_MAX);
    } catch (e) {}
}

function CSQlite(filename) {

    //this.sqlite3 = require('sqlite3');
    this.locked = false;

    this.me = this;
    if (filename) {
        this.filename = filename;
        //this.db = new sqlite3.Database(filename);
    }
    this.execute("PRAGMA journal_mode=DELETE");
    this.execute("PRAGMA synchronous=NORMAL");
    this.execute("PRAGMA busy_timeout=10000");

    this.remote = false;
	this.requestno=0;
	this.debug=0;


}
//------------------------------------------------------------------------------


CSQlite.prototype.execute = function(sql, local) {
    var dfd = jQuery.Deferred();
    var sqldonedef = jQuery.Deferred();
    var sqltask = {
        "deferred": dfd,
        "SQL": sql,
        "defdone": sqldonedef,
        "retries": 1,
        "db": this.filename,
        "this": this,
        "local": local,
		"requestno": this.requestno++,
		"debug": this.debug,
    };
	if (this.debug){
		log.add(1, "Info", "SQLite", "Execute: "+ sqltask.requestno+", SQL: "+ sqltask.SQL);
	}
    queue.enqueue(sqltask);
    var length = queue.getLength();
    if ((length == 1) && (!this.locked)) {
        this.executeTask();
    }
    return dfd.promise();
}

// Fuer window.onerror (main-fnc.js): bei einem Fehler ohne Error-Objekt die
// wartenden SQL-Auftraege bis auf den laufenden verwerfen - wie im Legacy,
// das dafuer die damals globale queue direkt leerte.
CSQlite.prototype.queueLeeren = function() {
    while (queue.getLength() > 1)
        queue.dequeue();
}

CSQlite.prototype.executeTask = function() {

    var sqltask = queue.peek();
    var me = this;

    if (sqltask) {
        var sqldonedef = sqltask.defdone;
        var dfd = sqltask.deferred;
        var sql = sqltask.SQL; //String(sqltask.SQL);
        var local = sqltask.local;
	var db =  sqltask.db;
        this.executeSQL(sql, null, db, local);
        $.when(sqldonedef).done(function() {
            queue.dequeue();
            me.executeTask();
        });
    }
}


CSQlite.prototype.executeSQL = function(sql, counter, db, local) {

    //var db = { db : new sqlite3.Database('path'), locked : "UNLOCKED", work_queue : [] }
    /*if ((sql.indexOf('SHOPS')<0) &&  (sql.indexOf('PRAGMA')<0) && !this.remote){
    	this.remoteQuery(sql);
    	return;
    }*/
var me =this;
    sql = String(sql);

//------------test---------
/*POS.Master="127.0.0.1";
POS.POSType == "Slave";
local = false;
this.remoteQuery(sql,db);
return;*/
//end test
    if (POS.POSType == "Slave") {
        if (local && local == true) {} else {
            switch (true) {
                case (sql.indexOf(" EMAILS ") > 0):
                case (sql.indexOf(" TIMEREC ") > 0):
                case (sql.indexOf(" PRODSTOCK ") > 0):
                case (sql.indexOf(" ZIPS ") > 0):
                    recordRouting("master", sql);
                    this.remoteQuery(sql,db);
                    return;
                    break;
            }
        }
    }
    recordRouting("lokal", sql);

$.ajax({
    url: "sqlite",
    data: {
        "query": sql,
	"db": db
         },
    cache: false,
    timeout: 900000,
    type: "POST",
    success: function(response) {
		response = JSON.parse(response);
        	me.ResultCallbackFunc(null,response);
    },
    error: function(xhr) {
                me.ResultCallbackFunc("err");

    }
});

/*
    if (!db) {
        db = new this.sqlite3.Database(this.filename); //,sqlite3.OPEN_READWRITE | sqlite3.OPEN_CREATE);
        var sqltask = queue.peek();
        sqltask.db = db;
    }

  var result = null;



    if (sql.indexOf("SELECT") == 0) {
        db.all(sql, this.ResultCallbackFunc);
    } else {
        db.run(sql, this.ResultCallbackFunc);
    }
*/
}

CSQlite.prototype.ResultCallbackFunc = function(err, rows) {

    var sqltask = queue.peek();
	if (sqltask.debug){
		log.add(1, "Info", "SQLite", "Result: "+ sqltask.requestno);
	}
    if (err) {
        if (sqltask.retries > 1) {
          //  sqltask.deferred.reject(err);
            // ACHTUNG: Der Fehler wird hier fuer den Aufrufer als LEERES
            // Ergebnis aufgeloest (resolve statt reject) - Aufrufer koennen
            // "DB-Fehler" nicht von "keine Zeilen" unterscheiden. Stufe 1 der
            // Robustheits-Haertung (Plan sharded-hatching-clover, Phase 1):
            // unveraendert resolven, aber jeden verschluckten Fehler mit
            // eindeutigem Marker persistieren + im Fenster zaehlen, damit
            // Suite-/Soak-Laeufe die tatsaechlich auftretenden Faelle zeigen,
            // BEVOR Stufe 2 auf echte Fehlerpfade (reject) umstellt.
            window.POSDIAG = window.POSDIAG || {};
            window.POSDIAG.sqlSwallowed = window.POSDIAG.sqlSwallowed || [];
            window.POSDIAG.sqlSwallowed.push({ when: new Date().toISOString(), err: String(err), sql: String(sqltask.SQL) });
            sqltask.deferred.resolve();
            sqltask.defdone.resolve();
            log.add(1, "Error", "SQLite VERSCHLUCKTER FEHLER (als leeres Ergebnis aufgeloest)", err + " " + sqltask.SQL);
            // Stufe 2a: sichtbar machen statt nur loggen - die Kassiererin
            // muss wissen, dass ein DB-Vorgang fehlgeschlagen sein kann
            // (Vorgang pruefen/wiederholen). Guard: sehr fruehe Fehler vor
            // Bundle-/Message-Init duerfen nicht selbst crashen.
            try {
                if (window.DialogService && POS && POS.message)
                    window.DialogService.warn(POS.lang.getText("MESSAGES", "DB_ERROR_CHECK") ||
                        "Datenbankfehler - bitte letzten Vorgang kontrollieren!");
            } catch (e) {}
            return;
        } else {
            sqltask.retries = sqltask.retries + 1;
            // Retry reicht das local-Flag mit durch (frueherer Bug: es ging
            // verloren, ein lokal erzwungener Query konnte beim Retry auf
            // einer Slave-Kasse zum Master umgeleitet werden).
            log.add(1, "Error", "SQLite RETRY nach Fehler", err + " " + sqltask.SQL);
            sqltask.this.executeSQL(sqltask.SQL, 0, sqltask.db, sqltask.local);
            dump("Error " + sqltask.retries + "! " + err + "\n" + sqltask.SQL);
            return;
        }
    }
    if (rows) {
        sqltask.deferred.resolve(rows);
        sqltask.defdone.resolve();
        if (sqltask.retries > 1) {
            log.add(4, "Info", "SQLite", "Resolved error : " + sqltask.SQL);
            dump("Resolved error ! " + sqltask.SQL);
        }
        return;
    } else {
        sqltask.deferred.resolve();
        sqltask.defdone.resolve();
    }

}

CSQlite.prototype.unlock = function() {
    this.locked = false;
    this.executeTask();
}

CSQlite.prototype.lastInsertId = function(idname, tablename) {
    var dfd = jQuery.Deferred();
    if (!idname) {
        idname = "BON_ID";
    }
    if (!tablename) {
        tablename = "BON";
    }
    var sql = "SELECT max(" + idname + ") as ID from " + tablename;
    $.when(this.execute(sql)).then(function(rows) {
		var rowid = 9999999;
		if (rows && rows[0]){
			rowid=rows[0].ID;
		}
        dfd.resolve(rowid);
    });
    return dfd.promise();
}

// INSERT und die Abfrage seiner Nummer OHNE Luecke dazwischen: beide werden
// sofort hintereinander in die (eine, globale) Warteschlange gestellt. Frueher
// kam "SELECT max(...)" erst im then() des INSERT - zwei gleichzeitige
// Anlagen (Doppeltipp auf "Bankomat", Filiale Breitenfurt 12.10.2026) liefen
// dann INSERT, INSERT, max, max und bekamen BEIDE die zweite Nummer. Die
// SQL-Texte bleiben zeichengleich (Routing, Runbook-Regel 3). Liefert ein
// jQuery-Deferred mit der Nummer (Regel 4).
CSQlite.prototype.insertMitId = function(sql, idname, tablename) {
    var dfd = jQuery.Deferred();
    var eingefuegt = this.execute(sql);
    var nummer = this.lastInsertId(idname, tablename);
    $.when(eingefuegt).then(function() {
        $.when(nummer).then(function(id) {
            dfd.resolve(id);
        });
    });
    return dfd.promise();
}

CSQlite.prototype.lastInsertBonRegId = function(idname, tablename) {
    var dfd = jQuery.Deferred();
    if (!idname) {
        idname = "ReceiptID";
    }
    if (!tablename) {
        tablename = "BONREG";
    }
    var sql = "SELECT max(" + idname + ") as ID from " + tablename;
    var r = this.execute(sql);
    $.when(r).then(function(rows) {
        dfd.resolve(rows[0].ID);
    });
    return dfd.promise();
}

CSQlite.prototype.getColumnNames = function(tablename) {

    var sql = "SELECT sql FROM sqlite_master WHERE tbl_name = " + tablename + " AND type = 'table'";
    return this.execute(sql);

}


CSQlite.prototype.remoteQuery = function(sql,db) {
    var me = this;
    $.ajax({
            method: "POST",
            url: "corsproxy.php",
            data: {
		"url": "http://" + POS.Master + ":8889/sqlite",
                "query": sql,
		"db": db
            },
	    timeout: 2000,
            success: me.queryAnswer,
            error: me.queryError
        })
        .done(function(msg) {
            //alert( "Data Saved: " + msg );
        });
}



CSQlite.prototype.queryAnswer = function(content) {
    if (content && content.length > 1 && (!(content.startsWith("NOK") ) ) && (!(content.includes("Bad Gateway"))) ){
          var rows = JSON.parse(content);
	} else {
	  log.add(1, "Error", "SQLite", "Receive: "+ content+", SQL: ");
	  rows={};
	}
    POS.SQLiteCon.ResultCallbackFunc(null, rows);
}

CSQlite.prototype.queryError = function(jqXHR, errstr, err) {
    errstr = "Abfrage beim Master fehlgeschlagen!";
    POS.SQLiteCon.ResultCallbackFunc(errstr, null);
}

export { CSQlite };
